import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 6C16 9.44771 13.4477 11 12 11C10.5523 11 8 9.44771 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
      <path
        d="M3 18.0248C3 16.7639 3.77608 15.681 4.92023 15.337C7.01957 14.7058 9.86554 14 12 14C14.1345 14 16.9804 14.7058 19.0798 15.337C20.2239 15.681 21 16.7639 21 18.0248V21H3V18.0248Z"
        stroke="#0090FF"
        strokeWidth="2"
      />
    </svg>
  );
};

export default Svg;
